import Gdpr from "./gdpr";
//import MouseWheelFacebook from "./mouse-wheel-facebook";
//import MouseWheelVimeo from "./mouse-wheel-vimeo";
//import MouseWheelYoutube from "./mouse-wheel-youtube";
import ProductViewer from "./product-viewer";
import SiteCart from "./site-cart";
import SiteFooter from "./site-footer";
//import SiteHeader from "./site-header";
import SiteNav from "./site-nav";
import SiteSearch from "./site-search";
import SiteWishlist from "./site-wishlist";
//import SiteVideo from "./site-video";

export default {
  Gdpr,
  ProductViewer,
  //GForm,
  //MouseWheelFacebook,
  //MouseWheelVimeo,
  //MouseWheelYoutube,
  SiteCart,
  SiteFooter,
  //SiteHeader,
  SiteNav,
  SiteSearch,
  SiteWishlist,
  //SiteVideo,
};
